export default function setupProfileTabs() {
    document.querySelectorAll('[data-profile-tabs]').forEach((tabs) => {
        const tabButtons = Array.from(tabs.querySelectorAll('[role="tab"]'));
        const panels = Array.from(tabs.querySelectorAll('[role="tabpanel"]'));

        if (!tabButtons.length || !panels.length) {
            return;
        }

        const getPanel = (tab) => panels.find((panel) => panel.id === tab.getAttribute('aria-controls'));
        const getTabForPanelId = (id) => tabButtons.find((tab) => tab.getAttribute('aria-controls') === id);
        const firstVisibleTab = tabButtons.find((tab) => Boolean(getPanel(tab)));

        const activateTab = (tab, updateHash = false) => {
            const panel = getPanel(tab);
            if (!panel) {
                return;
            }

            tabButtons.forEach((button) => {
                const selected = button === tab;
                button.setAttribute('aria-selected', String(selected));
                button.tabIndex = selected ? 0 : -1;
            });

            panels.forEach((item) => {
                item.hidden = item !== panel;
            });

            if (updateHash) {
                window.history.replaceState(null, '', `#${panel.id}`);
            }
        };

        const getInitialTab = () => {
            const hash = window.location.hash.replace(/^#/, '');
            if (hash) {
                const hashTab = getTabForPanelId(hash);
                if (hashTab) {
                    return hashTab;
                }
            }

            if (new URLSearchParams(window.location.search).has('start')) {
                const discussionsTab = getTabForPanelId('profile-discussions');
                if (discussionsTab) {
                    return discussionsTab;
                }
            }

            return tabButtons.find((tab) => tab.getAttribute('aria-selected') === 'true') || firstVisibleTab;
        };

        tabButtons.forEach((tab, index) => {
            tab.addEventListener('click', () => activateTab(tab, true));
            tab.addEventListener('keydown', (event) => {
                if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
                    return;
                }

                event.preventDefault();

                let nextIndex = index;
                if (event.key === 'ArrowLeft') {
                    nextIndex = index === 0 ? tabButtons.length - 1 : index - 1;
                } else if (event.key === 'ArrowRight') {
                    nextIndex = index === tabButtons.length - 1 ? 0 : index + 1;
                } else if (event.key === 'Home') {
                    nextIndex = 0;
                } else if (event.key === 'End') {
                    nextIndex = tabButtons.length - 1;
                }

                tabButtons[nextIndex].focus();
                activateTab(tabButtons[nextIndex], true);
            });
        });

        const initialTab = getInitialTab();
        if (initialTab) {
            activateTab(initialTab);
        }
    });
}
